import {
	AfterContentChecked,
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output
} from '@angular/core';
import {
	FormControlBase,
	FormControlBaseComponent
} from '@app/core/bases/form-control-base/form-control-base.component';
import {
	debounceTime,
	distinctUntilChanged,
	takeUntil
} from 'rxjs/operators';

@Component( {
	selector: 'app-form-input[formEntityId][formGroup][config]',
	templateUrl: './form-input.component.html',
	styleUrls: [ './form-input.component.scss' ]
} )
export class FormInputComponent extends FormControlBaseComponent implements FormControlBase, AfterViewInit, OnInit, AfterContentChecked {

	private _inputType: string;
	private _numberStep = 1;

	public showPassword: boolean;

	@Input() minNumber: number;
	@Input() maxNumber: number;

	@Input() inputWrapperStyleClass = '';

	@Input() hasInputAppendedContent = false;

	@Input() set numberStep( numberStep: number ) {
		this._numberStep = numberStep ?? 1;
	}

	get numberStep(): number {
		return this._numberStep;
	}

	@Input() set inputType( inputType: string ) {
		this._inputType = inputType ?? 'text';
		if ( this.config ) {
			this.config.type = this._inputType;
		}
	}

	get inputType(): string {
		return this._inputType;
	}

	@Output() changeEventEmitter: EventEmitter<string> = new EventEmitter<string>();
	@Output() blurEventEmitter: EventEmitter<string> = new EventEmitter<string>();

	constructor(
		private changeDetectorRef: ChangeDetectorRef
	) {
		super();
	}

	private clearOnEmptyString( inputValue: string ): void {
		if ( inputValue === '' ) { this.clearControlValue(); }
	}

	ngOnInit() {
		super.ngOnInit();
		this.config.type = this.config.type ?? 'text';
		this.inputType = this.inputType ?? this.config.type;
		this.showPassword = this.config.type === 'password';

		this.control?.valueChanges
		.pipe(
			takeUntil( this.ngUnsubscribe ),
			distinctUntilChanged(),
			debounceTime( 300 )
		)
		.subscribe( ( inputValue: string ) => {
			const hasValue: boolean = !!inputValue;
			this.changeEventEmitter.emit( inputValue );
			this.updateActionButtonsVisibility( hasValue );
			this.updateRevertValue( inputValue );
			this.clearOnEmptyString( inputValue );
		} );
	}

	ngAfterContentChecked() {
		this.changeDetectorRef.detectChanges();
	}

	ngAfterViewInit(): void {
		super.ngAfterViewInit();
	}

	onBlurEvent() {
		this.blurEventEmitter.emit( this.control?.value );
	}

	togglePassword() {
		this.showPassword = !this.showPassword;
		this.inputType = this.showPassword ? 'password' : 'text';
	}

	updateRevertValue( val: string ) {
		if ( val ) { this.revertValue = val; }
	}
}
